// AUTO-GENERATED CODE, DO NOT EDIT!
/* eslint-disable */

import * as Types from '../../../generated-types'

import gql from 'graphql-tag'
export type EnquiryFragment = {
  __typename?: 'Interest'
  enquiry: {
    __typename?: 'Enquiry'
    uuid: string
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  }
}

export type VenueCardFragment = {
  __typename?: 'Interest'
  id: number
  recommended: boolean
  message?: {
    __typename?: 'Message'
    id: number
    creationDate: any
    text: string
    email: string
    phone?: string | null
    cardSeen: boolean
    seenAt?: any | null
    relevancyFit: Types.RelevancyFit
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      url?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  } | null
  enquiry: {
    __typename?: 'Enquiry'
    uuid: string
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  }
}

export type MatchedVenueCardFragment = {
  __typename?: 'Interest'
  matchedAt?: any | null
  id: number
  recommended: boolean
  message?: {
    __typename?: 'Message'
    id: number
    creationDate: any
    text: string
    email: string
    phone?: string | null
    cardSeen: boolean
    seenAt?: any | null
    relevancyFit: Types.RelevancyFit
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      url?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  } | null
  enquiry: {
    __typename?: 'Enquiry'
    uuid: string
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  }
}

export type DirectEnquiryMessageCardFragment = {
  __typename?: 'Interest'
  id: number
  recommended: boolean
  message?: {
    __typename?: 'Message'
    id: number
    creationDate: any
    text: string
    email: string
    phone?: string | null
    cardSeen: boolean
    seenAt?: any | null
    relevancyFit: Types.RelevancyFit
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      url?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  } | null
  enquiry: {
    __typename?: 'Enquiry'
    uuid: string
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  }
}

export type DeclinedMessageCardFragment = {
  __typename?: 'Interest'
  id: number
  recommended: boolean
  message?: {
    __typename?: 'Message'
    declinedAt?: any | null
    id: number
    creationDate: any
    text: string
    email: string
    phone?: string | null
    cardSeen: boolean
    seenAt?: any | null
    relevancyFit: Types.RelevancyFit
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      url?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  } | null
  enquiry: {
    __typename?: 'Enquiry'
    uuid: string
    venue?: {
      __typename?: 'Venue'
      name: string
      imageUrl?: string | null
      tour3dUrl?: string | null
      spaceName?: string | null
      nearestTransit?: {
        __typename?: 'NearestTransit'
        distance_km: number
        station: string
      } | null
    } | null
  }
}

export const EnquiryFragmentDoc = gql`
  fragment Enquiry on Interest {
    enquiry {
      uuid
      venue {
        name
        imageUrl
        tour3dUrl
        spaceName
        nearestTransit {
          distance_km
          station
        }
      }
    }
  }
`
export const VenueCardFragmentDoc = gql`
  fragment VenueCard on Interest {
    id
    recommended
    message {
      id
      creationDate
      text
      email
      phone
      cardSeen
      seenAt
      relevancyFit
      venue {
        name
        imageUrl
        tour3dUrl
        url
        spaceName
        nearestTransit {
          distance_km
          station
        }
      }
    }
    ...Enquiry
  }
  ${EnquiryFragmentDoc}
`
export const MatchedVenueCardFragmentDoc = gql`
  fragment MatchedVenueCard on Interest {
    ...VenueCard
    matchedAt
  }
  ${VenueCardFragmentDoc}
`
export const DirectEnquiryMessageCardFragmentDoc = gql`
  fragment DirectEnquiryMessageCard on Interest {
    id
    ...VenueCard
  }
  ${VenueCardFragmentDoc}
`
export const DeclinedMessageCardFragmentDoc = gql`
  fragment DeclinedMessageCard on Interest {
    id
    ...VenueCard
    message {
      declinedAt
    }
  }
  ${VenueCardFragmentDoc}
`
